import { Description } from '@radix-ui/react-dialog'
import { cn } from '@seen/ui'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'

export type DescriptionProps = ComponentPropsWithoutRef<typeof Description>

export interface DialogDescriptionProps extends DescriptionProps {
  children?: DescriptionProps['children']
  asChild?: DescriptionProps['asChild']
  className?: DescriptionProps['className']
}

export const DialogDescription = forwardRef<
  ElementRef<typeof Description>,
  DialogDescriptionProps
>(({ className, ...delegated }, ref) => (
  <Description
    ref={ref}
    className={cn('max-w-none text-muted-foreground text-sm', className)}
    {...delegated}
  />
))
DialogDescription.displayName = Description.displayName
